export enum BattGRegistrationStep {
  ManufacturerBaseData,
  MainContactData,
  RepresentativeData,
}
